module.exports = __webpack_public_path__ + "static/media/Rodgers_and_Hart.89cbced1.jpg";